import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/dist/vuetify.min.css';
import en from 'vuetify/src/locale/en';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#00a0ff',
        secondary: '#ff9800',
      },
    },
  },
  lang: {
    locales: {en},
    current: 'en',
  },
});
